module.exports = __webpack_public_path__ + "assets/6195e04979c3649192bba11f75c6bb4c.png";